//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum CatalogPriceListUsage {
	InheritsFromUserPermits = 0,
	DisableUserChange = 1,
	EnableUserChange = 2
}
